<template>
  <div>
    <ul class="plcBar unstyled horizontal hidden-xs" style="width:100%;">
      <li data-stage="birth" class="position-relative" style="width:20%; background-color:#3498db; height:5px;"></li>
      <li data-stage="growth" class="position-relative " style="width:30%; background-color:#27ae60; height:5px;"></li>
      <li data-stage="maturity" class="position-relative " style="width:30%; background-color:#fda529; height:5px;"></li>
      <li data-stage="death" class="position-relative " style="width:20%; background-color:#bdc3c7; height:5px;"></li>
    </ul>

    <div class="container margin-y-xxxl">
      <div class="text-center mobile-only"><img src="/static/logo_leadsocial_color.svg" width="250" height="42" style="height:39px; margin-top:20px; margin-bottom:40px;" alt="LeadSocial ROI"></div>

      <div class="row">
        <div class="col-lg-5 col-lg-offset-1">
          <h1 class="unbold">About</h1>
          <p>LeadSocial has been discontinued.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  mounted () {
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/About.vue